import { useEffect, useState } from "react";
import { useNavigation } from "react-router-dom";
import logo from "../../../assets/logo-img.svg";

export default function CompanyStepThree({ num, handleDecrement }) {
  const [isScheduled, setIsScheduled] = useState(false);
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  useEffect(() => {
    const container = document.getElementById("calendly-inline-widget");
    if (container) {
      container.innerHTML = "";
      window.Calendly.initInlineWidget({
        url: "https://calendly.com/devmail172/30min",
        parentElement: container,
      });
    }

    function handleCalendlyEvent(event) {
      if (event.origin.includes("calendly.com")) {
        if (
          event.data.event &&
          event.data.event === "calendly.event_scheduled"
        ) {
          setIsScheduled(true);
        }
      }
    }

    window.addEventListener("message", handleCalendlyEvent);

    return () => {
      window.removeEventListener("message", handleCalendlyEvent);
    };
  }, []);

  return (
    <div className="company-introduction-call">
      <div className="row-essy">
        <div className="col-essy-lg-6 col-essy-md-6">
          <div className="company-introduction-wrapper">
            <img src={logo} alt="logo" />
            <span>Step {num} of 3</span>
            <h2>Company Details and Introduction Call</h2>
            <p>Choose must-have skills for your candidate</p>
            <div className="company-introduction-wrapper__button">
              <button
                type="submit"
                className={`${
                  !isScheduled ? "btn-disabled" : ""
                } btn-all-white`}
                disabled={!isScheduled}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
              <button
                type="button"
                onClick={handleDecrement}
                className="btn-back"
              >
                Back
              </button>
            </div>
          </div>
        </div>
        <div className="col-essy-lg-6 col-essy-md-6">
          <div className="schedule-call-wrapper">
            <div id="calendly-inline-widget"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
